import RedTshirt from './RedShirt.jpeg'
import BlueTshirt from './blueShirt.jpeg'
import GreenTshirt from './greenShirt.jpeg'

let data_product = [
  
 {
    id:10,
    name:"Zip-neck T-shirt",
    image:RedTshirt,
    new_price:1599,
    old_price:1800,
    color:"Red and White",
  },
 
  {id:20,
    name:"Zip-neck T-shirt",
    image:BlueTshirt,
    new_price:1599,
    old_price:1800,
    color:"Blue and White",
  },

  
  {id:30,
    name:"Zip-neck T-shirt",
    image:GreenTshirt,
    new_price:1599,
    old_price:1800,
    color:"Green and White",
  },

 
];

export default data_product;
